import ActionsForm from '@/shared/mixins/actionsForm'
import CityRepository from '@/shared/http/repositories/geo/city'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import { loading } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'Searchenterprise',
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ
  },
  data () {
    return {
      citys: [],
      title: 'Buscar Empreendimento ',
      formSearch: {
        cidade: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        empreendimentoid: '',
        status: ''
      },
      allEmpreendimento: [],
      dataEnum: [],
      filterOn: false
    }
  },
  mounted () {
    this.getCidade()
    this.getAllStatus()
    this.getAllEmpreendimento()
  },
  methods: {
    getCidade () {
      loading.push()
      CityRepository.GetAll()
        .then(Response => loading.pop())
        .catch(Error => loading.pop())
    },
    Clear () {
      localStoreHelper.gestao.empreendimento(null)
      this.$refs.CidadeTypeahead.clear()
      Object.keys(this.formSearch).forEach(prop => {
        if (prop === 'cidade') {
          this.formSearch[prop].value = null
        } else {
          this.formSearch[prop] = ''
        }
      })
    },
    getAllEmpreendimento () {
      loading.push()
      EnterpriseRepository.GetAll()
        .then(Response => {
          this.allEmpreendimento = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    Search () {
      let data = {
        CidadeId: this.formSearch.cidade.value === '' ? null : this.formSearch.cidade.value,
        EmpreendimentoId: this.formSearch.empreendimentoid === '' ? null : this.formSearch.empreendimentoid,
        Status: this.formSearch.status === '' ? null : this.formSearch.status,
        Unidade: this.formSearch.Unidade.value === '' ? null : this.formSearch.Unidade.value
      }
      localStoreHelper.gestao.empreendimento(data)
      this.$emit('filter', data)
    },
    getAllStatus () {
      loading.push()
      EnterpriseRepository.GetEnum()
        .then(Response => {
          loading.pop()
          this.dataEnum = Response.data
        })
        .catch(Error => loading.pop())
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/searchenterprise/searchenterprise.js